import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Filtering from "./Filtering";
import BrandBasedSalesReportsTable from "./BrandBasedSalesReportsTable";
import ProductBasedSalesReports from "./ProductBasedSalesReports";
import CategoryBasedSalesReportsTable from "./CategoryBasedSalesReportsTable";
import moment from "moment";

const SalesReports = () => {
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const listParam = urlParams.get('list');
    const [filter, setFilter] = useState({
        startDate: moment().subtract(12, 'months').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
    });
    return (
        <React.Fragment>
            <Filtering setFilter={setFilter} listParam={listParam} />
            {listParam === 'product-based' ? (
                <ProductBasedSalesReports filter={filter} />
            ) : listParam === 'brand-based' ? (
                <BrandBasedSalesReportsTable filter={filter} />
            ) : listParam === 'category-based' ? (
                <CategoryBasedSalesReportsTable filter={filter} />
            ) : (
                null
            )}
        </React.Fragment >
    )
}

export default SalesReports;